import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';
import { Link, Typography } from '@mui/material';
import React from 'react'
import { PureLightThemeCaaS } from 'src/theme/schemes/PureLightTheme';
import { getPrivacyPolicyUrl, getTermsConditionsUrl } from 'src/utils/legalPageUrls';

const termsConditionsUrl = getTermsConditionsUrl();
const privacyPolicyUrl = getPrivacyPolicyUrl();


interface LoginFormTextProps {
    platformSelected?: string;
}

const LoginFormText: React.FC<LoginFormTextProps> = ({ platformSelected }) => {
    return (
        <>
            <Typography variant="h6" color={PureLightThemeCaaS.colors.alpha.black[100]} textAlign="left">
                {/* I authorize RotoGPT to access my {platformSelected.name} account data on my behalf. RotoGPT does not store my username or password, only a secure access token issued by {platformSelected.name}. 
                          This token allows data retrieval and can be revoked anytime by disconnecting your account. */}

                I authorize RotoGPT to access my {platformSelected} account data on my behalf. By connecting my account, I agree to RotoGPT's{" "}
                <Link
                    href={termsConditionsUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="none"
                    onClick={async (e) => {
                        if (Capacitor.isNativePlatform()) {
                            e.preventDefault();
                            await Browser.open({ url: termsConditionsUrl });
                        }
                    }}
                    sx={{ color: "#1976d2", textDecoration: "underline" }}
                >
                    Terms and Conditions
                </Link>
                {" "}and acknowledge the{" "}
                <Link
                    href={privacyPolicyUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="none"
                    onClick={async (e) => {
                        if (Capacitor.isNativePlatform()) {
                            e.preventDefault();
                            await Browser.open({ url: privacyPolicyUrl });
                        }
                    }}
                    sx={{ color: "#1976d2", textDecoration: "underline" }}
                >
                    Privacy Policy
                </Link>.
            </Typography>
        </>
    )
}

export default LoginFormText